<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>About</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 公司簡介 -->
      <section id="lsyg">
        <div class="banner-bottom">
          <div class="onlyPC">
            <div class="col-lg-5 banner-bottom-left1">
              <div class="banner-bottom-left1-grid">
                <h3>Milestone of Far East Group</h3>
                <div class="progress progress1">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  Far East Steel Structure was founded in 1994 by a group of
                  engineers who were well-versed in the steel structure
                  specifications of the United States, Japan, Australia, and
                  other countries. In the early development stages, we assisted
                  numerous Taiwanese and foreign companies in establishing
                  factories in South China and East China. Our clients include
                  prominent information and communication electronics companies
                  such as Acer, Compal, Nanya, Taiwan Optoelectronics, and VIA,
                  as well as key players in the semiconductor industry, like
                  TSMC, Samsung Electronics, and Intel. With 30 years of
                  experience, we now employ over 500 people worldwide and have
                  expanded our professional factory construction services to
                  North America, Europe, and other regions. Our products are
                  exported to more than 30 countries and markets, and we have
                  successfully completed over 4,000 diverse steel structure
                  engineering projects. These projects encompass production
                  plants, logistics facilities, residential and commercial
                  offices, public buildings, petrochemical plants, energy and
                  power facilities, mining operations, and high-rise buildings.
                </p>
              </div>
            </div>
            <div class="col-lg-7 banner-bottom-left2">
              <div class="grid">
                <figure>
                  <img
                    src="@/components/img/gyhy/3.jpg"
                    alt=""
                    class="showImg"
                  />
                </figure>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
        </div>
      </section>

      <!-- 華胤目標 -->
      <section>
        <div id="hymb">
          <div class="banner-bottom1 visible-lg">
            <div class="onlyPC">
              <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
                <div class="grid">
                  <figure>
                    <img
                      src="@/components/img/gyhy/2.jpg"
                      alt=""
                      class="showImg"
                    />
                  </figure>
                </div>
              </div>
              <div class="col-lg-5 banner-bottom-lft1">
                <h4>Far East Group Mission</h4>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  At Far East Group, our objective is to deliver high-quality
                  steel structure products and engineering project services. We
                  achieve this through continuous innovation, professional
                  design, and a focus on customer satisfaction. Our commitment
                  to quality means we uphold high standards, ensure timely
                  delivery of products, and maintain production safety, which
                  instills confidence in our clients and partners.
                </p>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
          <div class="banner-bottom1 hidden-lg">
            <div class="onlyPC">
              <div class="col-lg-5 banner-bottom-lft1">
                <h4>Far East Group Mission</h4>
                <div class="progress progress1 progress2">
                  <div
                    class="progress-bar progress-bar1"
                    role="progressbar"
                    aria-valuenow="40"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    style="width: 40%"
                  >
                    <span class="sr-only">40% Complete</span>
                  </div>
                </div>
                <p>
                  At Far East Group, our objective is to deliver high-quality
                  steel structure products and engineering project services. We
                  achieve this through continuous innovation, professional
                  design, and a focus on customer satisfaction. Our commitment
                  to quality means we uphold high standards, ensure timely
                  delivery of products, and maintain production safety, which
                  instills confidence in our clients and partners.
                </p>
              </div>
              <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
                <div class="grid">
                  <figure>
                    <img
                      src="@/components/img/gyhy/2.jpg"
                      alt=""
                      class="showImg"
                    />
                  </figure>
                </div>
              </div>

              <div class="clearfix"></div>
            </div>
          </div>
        </div>

        <div class="banner-bottom1" id="hyyj">
          <div class="onlyPC">
            <div class="col-lg-5 banner-bottom-lft1">
              <h4>Far East Group Vision</h4>
              <div class="progress progress1 progress2">
                <div
                  class="progress-bar progress-bar1"
                  role="progressbar"
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style="width: 40%"
                >
                  <span class="sr-only">40% Complete</span>
                </div>
              </div>
              <p>
                Far East Group's vision is to become the world's top steel
                structure construction group through continuous technology
                optimization and the use of steel structure construction for
                environmental protection, economy, safety, beautiful appearance,
                and material recycling advantages. This dedication to
                sustainability helps customers to create environmentally
                friendly engineering projects and fosters a high-quality working
                and living environment.
              </p>
            </div>
            <div class="col-lg-7 banner-bottom-left2 banner-bottom1-left2">
              <div class="grid">
                <figure>
                  <img
                    src="@/components/img/gyhy/4.jpg"
                    alt=""
                    class="showImg"
                  />
                </figure>
              </div>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </section>
      <!-- 工廠介紹 -->
      <section id="esg">
        <div class="container gradient-background">
          <!-- ESG -->
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>ESG</span></h1>
              <p class="rzp">
                Far East Group has embedded ESG principles across its
                third-generation Hai’an facility, prioritizing low-carbon
                construction and resource reuse. The building’s main steel
                structure repurposes components from the Group’s former Kunshan
                plant, reducing material consumption and construction-phase
                emissions while highlighting the modular and recyclable nature
                of steel.
              </p>
              <p class="rzp">
                The rooftop solar system, installed by subsidiary GS Solar
                Power, supplies over 50% of the plant’s electricity,
                significantly increasing renewable energy usage. The facility
                also features a rare, high-investment water-curtain mobile spray
                booth, cutting carbon emissions by 50% and VOCs by 70%,
                reflecting Far East Group’s commitment to environmental
                responsibility through concrete action.
              </p>
              <p class="rzp">
                The Group holds certifications for ISO 14001 and ISO 45001, and
                complies with EN1090 and ISO 3834, demonstrating its continued
                leadership in sustainable manufacturing and ESG-driven
                governance.
              </p>
            </div>
            <div class="col-lg-12 esgImgCon">
              <img src="@/components/img/gyhy/esg.png" alt="" class="esgImg" />
            </div>
          </div>

          <!-- 工廠介紹 -->
          <div class="row" id="gcjs">
            <div class="col-lg-12 rzTop">
              <h1><span>Factory Introduction</span></h1>
              <p>
                Far East Group has established several professional steel
                structure production plants across Asia, enabling them to supply
                materials according to the specific needs of local customers and
                the characteristics of various projects, thereby enhancing
                construction efficiency. One of their key facilities is located
                in Hai'an, Jiangsu, covering an area of 125,000 square meters,
                with a plant space of 63,000 square meters. This factory has an
                annual production capacity of 50,000 tons of steel components
                and 30,000 tons of color steel forming components. The factory
                utilizes advanced automated processing and painting equipment
                that complies with the latest environmental regulations,
                allowing it to handle heavy steel component projects. Since its
                inception, the company has adhered to its core values:
                continuous innovation, quality improvement, and honest service.
                Far East Group remains committed to providing customers with
                high-quality services and executing projects with excellence.
              </p>
              <div class="spaceCon">
                <div
                  class="col-lg-3 col-xs-6"
                  v-for="(item, index) in gcjsList"
                  :key="index"
                >
                  <div class="gcjsImg">
                    <img
                      v-lazy="item.image[0]"
                      alt=""
                      style="width: 100%; height: 100%"
                      :key="index"
                    />
                  </div>
                  <div class="gcjsp gcjsHeight" style="white-space: pre-line">
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 認證獎項 -->
          <div class="row" id="rzjx">
            <div class="col-lg-12 rzTop">
              <h1>
                <span>International Certification | Architecture Awards</span>
              </h1>
              <p>
                Far East Group holds {{ zzzsList.length }} international
                professional certifications in the field of steel structures.
                These include certifications from the American Institute of
                Steel Construction (AISC), the American Welding Society (AWS),
                the Canadian Welding Bureau (CWB), the Japan Steel Structure
                Appraisal Center (JSA), and the European ISO quality management
                system, among others. Each time we apply for certification or
                undergo annual renewal reviews, we enhance the effectiveness of
                our quality system and gain valuable insights from quality
                experts at international certification organizations. These
                efforts demonstrate our commitment to quality management and our
                determination to penetrate the global high-end market.
              </p>
              <p>
                Since its establishment, Far East Steel Structure has dedicated
                itself to enhancing product quality and the level of service in
                engineering projects. The company has received numerous
                commendations from government and professional organizations.
                While working on projects for internationally recognized
                engineering general contractors, customers have consistently
                acknowledged its efforts, resulting in the company being awarded
                the Excellent Supplier Award multiple times. Both owners and
                engineering general contractors have expressed their gratitude
                for the team's ability to execute tasks effectively, overcoming
                challenges to advance projects. Far East Group has also
                flourished in the construction engineering sector, garnering a
                total of 32 awards, including the Golden Steel Award, Top Ten
                Influential Brands, and Top Ten Outstanding Enterprises.
              </p>
            </div>
          </div>

          <!-- 國際認證 -->
          <div>
            <h2>
              <span class="hspan"
                ><span style="color: red">///////// </span>International
                Certification</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-4 col-xs-6"
              v-for="(item, index) in zzzsList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview gjrzImg">
                      <el-image
                        lazy
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                        fit="contain"
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content zzzsHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 建築獎項 -->
          <div>
            <h2>
              <span class="hspan"
                ><span style="color: red">///////// </span>Architecture
                Award</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-1-5 col-xs-4"
              v-for="(item, index) in jzjxList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview jzjxImg">
                      <el-image
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                        lazy
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content jzjxHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 感謝狀 -->
          <div>
            <h2>
              <span class="hspan2"
                ><span style="color: red">///////// </span>Appreciation |
                Trophy</span
              >
            </h2>
          </div>
          <div class="container-fluid">
            <div
              class="col-lg-1-5 col-xs-4"
              v-for="(item, index) in gxzList"
              :key="index"
            >
              <div class="portfolio-item">
                <div class="thumb">
                  <div class="image">
                    <div class="demo-image__preview jzjxImg">
                      <el-image
                        lazy
                        style="height: 100%"
                        :src="item.image[0]"
                        :preview-src-list="item.image"
                      >
                        <div slot="placeholder">
                          <img src="@/components/img/loading.gif" alt="" />
                        </div>
                        <div slot="error">
                          <img src="@/components/img/error.gif" alt="" />
                        </div>
                      </el-image>
                    </div>
                  </div>
                  <div class="hover-effect">
                    <div
                      class="hover-content jzjxHeight"
                      style="white-space: pre-line"
                    >
                      <h1>{{ item.text }}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div class="mailbg">
        <to-mail buttonText="REQUEST A QUOTE"></to-mail>
      </div>

      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i><a @click="forId('lsyg')">Milestone</a></i>
        </div>
        <div>
          <i><a @click="forId('hymb')">Mission</a></i>
        </div>
        <div>
          <i><a @click="forId('hyyj')">Vision</a></i>
        </div>
        <div>
          <i><a @click="forId('esg')">ESG</a></i>
        </div>
        <div>
          <i><a @click="forId('gcjs')">Factory</a></i>
        </div>
        <div>
          <i><a @click="forId('rzjx')">Certifications</a></i>
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      gcjsList: [
        {
          image: [require('@/components/img/gyhy/gcjs1.png')],
          text: 'Plants Area\n125,000 m²',
        },
        {
          image: [require('@/components/img/gyhy/gcjs2.png')],
          text: 'Painting Workshop\n10,000 m²',
        },
        {
          image: [require('@/components/img/gyhy/gcjs3.png')],
          text: 'Storage Area\n15,000 m²',
        },
        {
          image: [require('@/components/img/gyhy/gcjs4.png')],
          text: 'Maximum Single Lift Capacity: 40 Tons',
        },
        {
          image: [require('@/components/img/gyhy/gcjs5.png')],
          text: 'Painting Workshop Air Purification System',
        },
        {
          image: [require('@/components/img/gyhy/gcjs6.png')],
          text: '12,000W Laser Flat Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs7.png')],
          text: '5-Axis 3D H-Beam Laser Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs8.png')],
          text: 'Automatic Pipe Profile Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs9.png')],
          text: 'Plasma Section Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs10.png')],
          text: 'Multi-Torch Flame Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs11.png')],
          text: '20,000W Laser Flat Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs12.png')],
          text: 'CNC Plasma & Oxy-Fuel Plate Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs21.png')],
          text: 'Structural Steel Laser Cutting Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs13.png')],
          text: 'Environmentally Controlled Paint Booth',
        },
        {
          image: [require('@/components/img/gyhy/gcjs14.png')],
          text: 'Shot Blasting machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs15.png')],
          text: 'Robotic Welding System',
        },
        {
          image: [require('@/components/img/gyhy/gcjs16.png')],
          text: 'Submerged Arc Welding (SAW) System',
        },
        {
          image: [require('@/components/img/gyhy/gcjs17.png')],
          text: 'Electroslag Welding (ESW) System',
        },
        {
          image: [require('@/components/img/gyhy/gcjs18.png')],
          text: 'High-Speed 7-Axis CNC Drill Line',
        },
        {
          image: [require('@/components/img/gyhy/gcjs19.png')],
          text: 'Cnc Drilling Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs22.png')],
          text: 'Structural Steel CNC End Milling Machine',
        },
        {
          image: [require('@/components/img/gyhy/gcjs20.png')],
          text: 'Assembly Machine',
        },
      ],
      zzzsList: [
        {
          image: [require('@/components/img/gyhy/zzzs5.png')],
          text: 'American Institute of Steel Construction',
        },
        {
          image: [require('@/components/img/gyhy/zzzs8.png')],
          text: 'American Welding Society',
        },
        {
          image: [require('@/components/img/gyhy/zzzs6.png')],
          text: 'Canadian Welding Bureau CSA W47.1',
        },
        {
          image: [require('@/components/img/gyhy/zzzs9.png')],
          text: 'China Steel Structure Association-Grade l Fabrication Qualification',
        },
        {
          image: [require('@/components/img/gyhy/zzzs10-1.png')],
          text: 'European Standard for Steel Structure Fabrication-CE Marking Compliance',
        },
        {
          image: [require('@/components/img/gyhy/zzzs10-2.png')],
          text: 'European Standard for Steel Structure Fabrication-CE Marking Compliance',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzs14.png'),
            require('@/components/img/gyhy/zzzs15.png'),
          ],
          text: 'Japan Steel Assessment Center-Minister of Land, Infrastructure, Transport and Toursm Certified',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzs13.png'),
            require('@/components/img/gyhy/zzzs12.png'),
          ],
          text: 'International Standard for Quality Management Systems',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzsen2.png'),
            require('@/components/img/gyhy/zzzs2.png'),
            require('@/components/img/gyhy/zzzs4.png'),
          ],
          text: 'Occupational Health and Safety Management Systems',
        },
        {
          image: [
            require('@/components/img/gyhy/zzzsen1.png'),
            require('@/components/img/gyhy/zzzs1.png'),
            require('@/components/img/gyhy/zzzs3.png'),
          ],
          text: 'Environmental Management Systems',
        },
        {
          image: [require('@/components/img/gyhy/zzzs11.png')],
          text: 'Quality Requirements for Fusion Welding of Metallic Materials',
        },
        {
          image: [require('@/components/img/gyhy/zzzs16.png')],
          text: 'Canadian Certification of Steel Building System Manufacturers (CSA A660-10 Standard)',
        },
      ],
      jzjxList: [
        {
          image: [require('@/components/img/gyhy/ryzs1.jpg')],
          text: '1998 Far East Xiamen is the best-selling real estate product in Fujian Province',
        },
        {
          image: [require('@/components/img/gyhy/ryzs2.jpg')],
          text: '2000 Kunshan Far East Shanghai Steel Structure Association Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs3.jpg')],
          text: '2001 Kunshan Far East Shanghai Steel Structure Association Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs4.jpg')],
          text: '2002 Shanghai Far East Freight Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs5.jpg')],
          text: '2002 Shanghai Far East China Cargo Airlines Pudong Logistics Center Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs6.jpg')],
          text: '2003 Far East Kunshan Chuangzi Clothing Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs7.jpg')],
          text: '2003 Far East Kunshan Huisheng Science and Technology Park Golden Steel Award Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs8.jpg')],
          text: '2003 Shanghai Far East Mingchen Molding Golden Steel Award Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs9.jpg')],
          text: '2004 Kunshan Far East Jiaqi Building Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs10.jpg')],
          text: '2004 Kunshan Far East Secco Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs11.jpg')],
          text: '2004 Xiamen Far East Golden Steel Award - Tong Ren Hall',
        },
        {
          image: [require('@/components/img/gyhy/ryzs12.jpg')],
          text: '2005 Top ten outstanding enterprises of Far East Group',
        },
        {
          image: [require('@/components/img/gyhy/ryzs13.jpg')],
          text: '2005 The top ten influential brands of Far East Group',
        },
        {
          image: [require('@/components/img/gyhy/ryzs14.jpg')],
          text: '2005 Far East Xiamen Metal Structure Excellent Unit Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs15.jpg')],
          text: '2005 Far East Xiamen Minjiang Cup Honor Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs16.jpg')],
          text: '2006 Far East Kunshan IKEA Project Golden Steel Award',
        },
        {
          image: [require('@/components/img/gyhy/ryzs17.jpg')],
          text: '2006 Far East Xiamen ECCO Minjiang Cup',
        },
        {
          image: [require('@/components/img/gyhy/ryzs18.jpg')],
          text: '2006 Far East Xiamen Fujian Province Advanced Construction Enterprise Honor Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs19.jpg')],
          text: '2006 Far East Xiamen Fujian Province Famous Trademark Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs20.jpg')],
          text: '2006 Far East Xiamen Fujian Province Famous Trademark Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs21.jpg')],
          text: '2006 Far East is among the top 20 professional contractors in Xiamen',
        },
        {
          image: [require('@/components/img/gyhy/ryzs22.jpg')],
          text: '2007 Xiamen Far East is among the top 20 professional contractors',
        },
        {
          image: [require('@/components/img/gyhy/ryzs23.jpg')],
          text: '2008 Far East is a well-known brand product in Xiamen, Fujian',
        },
        {
          image: [require('@/components/img/gyhy/ryzs24.jpg')],
          text: '2008 Far East was an advanced collective in the earthquake relief efforts in Xiamen',
        },
        {
          image: [require('@/components/img/gyhy/ryzs25.jpg')],
          text: '2008 Far East Xiamen May Day Labor Award Certificate',
        },
        {
          image: [require('@/components/img/gyhy/ryzs26.jpg')],
          text: 'Suzhou Far East Port Quality Grade Certificate',
        },
      ],
      gxzList: [
        {
          image: [require('@/components/img/gyhy/gxz1.jpg')],
          text: '1996 Thank-you certificate from Suzhou Huabang Gaori Automobile',
        },
        {
          image: [require('@/components/img/gyhy/gxz2.jpg')],
          text: '2001 Far East Engineering Yiguang Electronics Appreciation Certificate',
        },
        {
          image: [require('@/components/img/gyhy/gxz3.jpg')],
          text: '2002 Thank-you Certificate from Far East Xiamen Liuhe Machinery',
        },
        {
          image: [require('@/components/img/gyhy/gxz4.jpg')],
          text: '2004 A confidential thank-you certificate from Far East Kunshan Suzhou Xinduan',
        },
        {
          image: [require('@/components/img/gyhy/gxz5.jpg')],
          text: '2005 Thank-you Certificate of Far East Kunshan Toyota Motor',
        },
        {
          image: [require('@/components/img/gyhy/gxz6.jpg')],
          text: '2005 Thank-you Letter from Far East Kunshan Ningbo Huayang',
        },
        {
          image: [require('@/components/img/gyhy/gxz7.jpg')],
          text: 'IBM Thank-you Letter',
        },
        {
          image: [require('@/components/img/gyhy/gxz8.jpg')],
          text: 'Thank-you Certificate of Feipeng Aluminum Industry',
        },
        {
          image: [require('@/components/img/gyhy/gxz9.jpg')],
          text: 'Fluor\nBASF Jade Tree Project\n"In Commemoration of Mechanical Completion"',
        },
        {
          image: [require('@/components/img/gyhy/gxz10.jpg')],
          text: 'MIH\nThe GPUFP Project\n“Thank You Award"',
        },
        {
          image: [require('@/components/img/gyhy/gxz11.jpg')],
          text: 'Fluor\nBASF IOU Project\n"Supplier Excellence Award"',
        },
        {
          image: [require('@/components/img/gyhy/gxz12.jpg')],
          text: 'Fluor\nBASF Maoming Project\n"Supplier Excellence Award"',
        },
        {
          image: [require('@/components/img/gyhy/gxz13.jpg')],
          text: 'Fluor\nAlbemarie MSH Project\n"Outstanding Contribution Purveyor"',
        },
        {
          image: [require('@/components/img/gyhy/gxz14.jpg')],
          text: 'Turner and Townsend\nStarbucks Kunshan Project\n"Safe Manhours 500.000"',
        },
        {
          image: [require('@/components/img/gyhy/gxz15.jpg')],
          text: 'Fluor\nBASF Infra Cluster Project\n"Big 30,000.000 Safe Working Hours"',
        },
        {
          image: [require('@/components/img/gyhy/gxz16.jpg')],
          text: 'Christiaens (China) Production Co., Ltd.\n“25 Tunnels - Phase 23 Project”',
        },
      ],
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      this.$store.dispatch('toID', tId)
    },
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
.slideImg {
  width: 100%;
  height: 100%;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideP {
  text-align: center;
  color: #000;
  font-size: 16px;
  line-height: 30px;
}

#rzjx,
#gcjs {
  border-top: 1px solid black;
}
.esgImgCon {
  text-align: center;
  margin-top: 0px;
  margin-bottom: 100px;
}
.esgImg {
  width: 70vw;
}

/* 榮譽圖片註釋設置 */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/gyhy/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}

/*-- banner-bottom --*/
.banner-bottom-left p {
  color: #fff;
  font-size: 14px;
  margin: 0;
  line-height: 1.8em;
}
.banner-bottom-left1 {
  border: 5px solid black;
  padding: 8em 5em 5em;
  background: #415160;
}
.banner-bottom-left2 {
  padding: 0;
}
.globe span {
  background: url(@/components/img/gyhy/img-sp.png) no-repeat 22px -81px;
  display: block;
  width: 128px;
  height: 128px;
  border: 1px solid #3f647d;
  border-radius: 100%;
}
.banner-bottom-left1-grid h3 {
  margin: 80px 0 40px;
  color: #fff;
  font-size: 40px;
  text-transform: capitalize;
}
.progress1 {
  height: 2px;
  margin-bottom: 0;
  border-radius: 0;
  margin: 1.5em 0 0;
}
.progress-bar1 {
  background: #eb6f63;
}
.banner-bottom-left1-grid p {
  margin: 40px 0 0;
  color: #fff;
  font-size: 20px;
  line-height: 36px;
}
.banner-bottom-left2 h3 {
  padding: 2em 2em 0;
  font-size: calc(100vw * 26 / 1644);
  color: #212121;
  margin: 0;
  line-height: 1.6em;
  position: relative;
}

/*-- effect --*/
.grid {
  position: relative;
  clear: both;
  margin: 0 auto;
  list-style: none;
  text-align: center;
  height: 100%;
}

/* Common style */
.grid figure {
  position: relative;
  float: none;
  margin: 0;
  min-width: 273px;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  text-align: center;
}

.grid figure img {
  position: relative;
  display: block;
  min-height: 100%;
  max-width: 100%;
  opacity: 0.8;
}

.grid figure figcaption {
  padding: 2em;
  color: #fff;
  text-transform: uppercase;
  font-size: 1.25em;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.grid figure figcaption::before,
.grid figure figcaption::after {
  pointer-events: none;
}

.grid figure figcaption,
.grid figure figcaption > a {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
/***** Lexi *****/
/*---------------*/

/*-- //effect --*/
/*-- //banner-bottom --*/
/*-- banner-bottom1 --*/
.banner-bottom-lft1 h3 {
  font-size: 5em;
  color: #fff;
  margin: 0;
}
.banner-bottom-left1,
.banner-bottom-lft1 {
  padding: 2.17em 4em 4em;
  /* background: #415160; */
  border-top: 10px double #58c5c8; /* 頂部5px寬的橙色雙線條邊框 */
  border-radius: 10px 10px 0 0; /* 頂部兩角更大的圓角 */
  border-bottom: none; /* 去除底部邊框 */
  border-left: none; /* 去除左邊框 */
  border-right: none; /* 去除右邊框 */

  /* 2. 更精致的背景效果 */
  background: radial-gradient(
    circle,
    #415160 0%,
    #415160 100%
  ); /* 從中心向外的白色到淺灰色漸變背景 */

  /* 4. 文本陰影效果 */
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.1);

  /* 5. 盒子陰影效果，更立體 */
  box-shadow: 0px -8px 8px -8px rgba(0, 0, 0, 0.2);

  /* 6. 透明度設置 */
  opacity: 0.95;
}
.banner-bottom-lft1 h4 {
  font-size: 40px;
  color: #fff;
  text-align: left;
  margin: 80px 0 40px;
}
.progress2 {
  margin: 1em 0 0;
}
.banner-bottom-lft1 p {
  margin: 40px 0 20px;
  color: #fff;
  font-size: 20px;
  line-height: 36px;
}
h4.with {
  text-align: left;
}

/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 10px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -205px;
}

#ss_menu div:nth-child(2) {
  top: -62px;
  left: -193px;
}

#ss_menu div:nth-child(3) {
  top: -123px;
  left: -170px;
}

#ss_menu div:nth-child(4) {
  top: -170px;
  left: -123px;
}

#ss_menu div:nth-child(5) {
  top: -193px;
  left: -62px;
}
#ss_menu div:nth-child(6) {
  top: -205px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

@property --s {
  syntax: '<length>';
  initial-value: 0px;
  inherits: true;
}

.showImg {
  --t: 3px; /* control the thickness (corner = 3*edge) */
  --s: 40px; /* control the size of the corners (that also affect the size of the edges) */
  --g: 8px; /* control the gap */
  --c: #755c3b;

  padding: calc(2 * var(--t) + var(--g));
  border: var(--t) solid #0000;
  background: conic-gradient(
        at var(--s) calc(3 * var(--t)),
        #0000 75%,
        var(--c) 0
      )
      0 0 / calc(100% - var(--s)) calc(100% - 3 * var(--t)) border-box,
    conic-gradient(at calc(3 * var(--t)) var(--s), #0000 75%, var(--c) 0) 0 0 /
      calc(100% - 3 * var(--t)) calc(100% - var(--s)) border-box,
    linear-gradient(0deg, var(--c) calc(2 * var(--t)), #0000 0) 50% var(--t) /
      calc(100% - 2 * (var(--s) + var(--g))) 100% repeat-y padding-box,
    linear-gradient(-90deg, var(--c) calc(2 * var(--t)), #0000 0) var(--t) 50%/100%
      calc(100% - 2 * (var(--s) + var(--g))) repeat-x padding-box;
  transition: --s 0.5s;
  cursor: pointer;
}
.showImg:hover {
  --s: 80px;
}

.rzTop {
  margin: 50px 0;
  text-align: center;
}
.rzTop h1 {
  margin: 50px 0;
}
.rzTop h1 span {
  padding-bottom: 0;
  font-size: 32px;
  font-weight: 800;
}
.rzTop p {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 20px;
  line-height: 40px;
}

.spaceCon {
  margin: 60px auto 0;
}

.gcjsTop {
  margin: 50px 0;
  text-align: center;
}
.gcjsTop h1 {
  margin: 50px 0;
}
.gcjsTop h1 span {
  padding-bottom: 10px;
  font-size: 34px;
  font-weight: 800;
}
.gcjsTop p {
  margin: 0 auto;
  width: 60vw;
  text-align: left;
  font-size: 22px;
  font-weight: 600;
  line-height: 40px;
}
.zzzsHeight {
  height: 80px;
}
.gcjsHeight {
  height: 70px;
}
.jzjxHeight {
  height: 100px;
}
.hover-content h1 {
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.onlyPC {
  display: flex;
}

.hspan,
.hspan2 {
  margin: 30px 10px;
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.gjrzImg,
.jzjxImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}
.gcjsImg {
  position: relative; /* 父容器設為相對定位 */
  width: 100%;
  height: 15vw; /* 按需設置高度 */
  margin: 0;
  text-align: center;
  background-color: #fff;
}
.gcjsp {
  margin: 20px 0;
}
.gcjsp p {
  width: auto;
  text-align: center;
  font-size: 18px;
  line-height: 30px;
}

div /deep/ .gjrzImg img {
  padding: 5px;
  width: 100%;
  height: 20vw;
  border: 0;
}

div /deep/ .jzjxImg img {
  padding: 5px;
  width: 100%;
  height: 10vw;
  border: 0;
}

.container-fluid {
  margin: 60px auto 0;
}

/* 漸變背景 */
.gradient-background {
  padding: 0 85px 100px;
  margin-top: 10px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}
.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

@media screen and (max-width: 1400px) {
  .grid figure img {
    width: 100%;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop h1 span {
    padding-bottom: 0;
    font-size: 26px;
    font-weight: 600;
  }
  .rzTop p {
    margin: 0 auto;
    width: 90vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 1.5;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    width: 100%;
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2 {
    margin: 10px;
    font-size: 22px;
  }
  .gcjsp p {
    width: auto;
    text-align: center;
    font-size: 18px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }
  .gcjsImg {
    height: 30vw;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsHeight {
    height: 60px;
  }
  div /deep/ .gjrzImg img {
    height: 50vw;
  }
  .hover-content h1 {
    font-size: 18px;
    margin: 10px 0;
  }
  .zzzsHeight {
    height: 80px;
  }
  .container-fluid {
    margin: 20px auto;
  }
  .jzjxHeight {
    height: 100px;
  }
  div /deep/ .jzjxImg img {
    height: 21vw;
  }
  .rzTop {
    margin: 0;
  }
  .row {
    margin: 0 !important;
  }
  .esgImgCon {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .esgImg {
    width: 70vw;
  }
  .banner-info span {
    font-size: 36px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }
  .mobh {
    font-size: 30px !important;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 26px;
    margin: 40px 0 20px;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 20px 0 10px 0;
    font-size: 19px;
    line-height: 1.5;
  }
  .banner-bottom-left1 {
    padding: 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 26px;
    margin: 40px 0 20px;
  }
  .banner-bottom-lft1 p {
    font-size: 19px;
    line-height: 1.5;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
}

@media screen and (max-width: 768px) {
  .mobh {
    font-size: 30px !important;
  }
  .banner-bottom-left1-grid p {
    margin: 40px 0 20px !important;
    font-size: 12px !important;
  }
  .banner {
    background: url(@/components/img/gyhy/1.jpg) -252px 0px no-repeat;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    -ms-background-size: cover;
  }
  .banner-bottom-left1-grid h3 {
    font-size: 20px;
    margin: 40px 0 20px;
  }
  .progress1 {
    margin: 1em 0 0;
  }
  .banner-bottom-left1-grid p {
    margin: 20px 0 0;
    font-size: 13px;
    line-height: 22px;
  }
  .banner-bottom-left1 {
    padding: 1em 1em 2em;
  }
  .m1 a {
    padding: 0px 80px 10px !important;
  }
  .grid figure figcaption {
    padding: 0em 1em;
  }
  .banner-bottom-left2 h3 {
    font-size: 1em;
    line-height: 1.8em;
  }
  .banner-bottom-lft1 {
    padding: 1em 1em 2em;
  }
  .banner-bottom-lft1 h4 {
    font-size: 20px;
    margin: 40px 0 20px;
  }
  .banner-bottom-lft1 p {
    font-size: 13px;
    line-height: 22px;
  }
  .equipmentList .equipmentListItem .ListItem .Item h5 {
    font-size: 18px;
  }
  .gradient-background {
    padding: 0;
    background: white;
  }
  .mailbg {
    background: white;
  }
  .rzTop h1 span {
    padding-bottom: 0;
    font-size: 20px;
    font-weight: 600;
  }
  .rzTop p {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    line-height: 20px;
  }

  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan,
  .hspan2 {
    font-size: 18px;
  }
  .gcjsp p {
    width: auto;
    text-align: center;
    font-size: 13px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }
  .gcjsImg {
    height: 30vw;
  }
  .gcjsp {
    margin: 10px 0;
  }
  .gcjsHeight {
    height: 60px;
  }
  div /deep/ .gjrzImg img {
    height: 60vw;
  }
  .hover-content h1 {
    font-size: 13px;
    margin: 10px 0;
  }
  .zzzsHeight {
    height: 70px;
  }
  .container-fluid {
    margin: 20px auto 0;
  }
  .jzjxHeight {
    height: 100px;
  }
  div /deep/ .jzjxImg img {
    height: 21vw;
  }
  .rzTop {
    margin: 0;
  }
  .row {
    margin: 0 !important;
  }
  .esgImgCon {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .esgImg {
    width: 70vw;
  }
  .banner-info {
    width: 90vw;
  }
  .banner-info span {
    font-size: 26px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }
}

@media screen and (min-width: 2000px) {
  .banner-bottom-left1-grid p {
    font-size: 29px;
    line-height: 1.8;
  }
  .banner-bottom-left1 {
    padding: 5em;
  }
  .banner-bottom-left1-grid h3 {
    margin: 90px 0 50px;
  }
  .banner-bottom-lft1 h4 {
    margin: 90px 0 50px;
  }
  .banner-bottom-lft1 p {
    font-size: 29px;
    line-height: 1.8;
  }
  .rzTop h1 span {
    font-size: 40px;
  }
  .rzTop p {
    font-size: 29px;
    line-height: 1.8;
  }
  .gradient-background {
    padding: 0 160px 100px;
  }
  .gcjsp p {
    font-size: 26px;
    line-height: 1.5;
  }
  .hover-content h1 {
    font-size: 26px;
    line-height: 1.5;
  }
  .zzzsHeight {
    height: 140px;
  }
  .jzjxHeight {
    height: 170px;
  }
  .banner-info span {
    font-size: 65px;
  }
  .gcjsHeight {
    height: 75px;
  }
}
</style>
